const CookieSettings = ({ label }: { label?: string }) => {
  const handleCookieSettings = () => {
    if (typeof window !== 'undefined' && window.OneTrust) {
      window.OneTrust.ToggleInfoDisplay()
    }
  }

  return (
    <div>
      <button onClick={handleCookieSettings}>{label || 'Cookies'}</button>
    </div>
  )
}

export default CookieSettings
